import { fromJS } from 'immutable';

import {
  SET_DISCUSSION,
  LOAD_DISCUSSION,
  LOAD_DISCUSSION_ERROR,
  LOAD_SENDBIRD_MESSAGES,
  LOAD_MORE_MESSAGES,
  UPDATE_MESSAGES,
  CLEAR_DISCUSSION,
  UPDATE_DOCUMENTS,
  REMOVE_DOCUMENT,
  UPDATE_DELIVERABLES,
  SET_DISCUSSION_TYPE,
  UPDATE_CURRENT_BRIEF,
  UPDATE_CURRENT_CONTRACT,
  UPDATE_SIGNED_CONTRACT,
  UPDATE_DELIVERABLE_DOCUMENT,
  UPDATE_TRACKED_ASSETS,
  UPDATE_DELIVERABLE_APPROVED,
  UPDATE_DELIVERABLE_APPROVED_SUCCESS,
  UPDATE_DELIVERABLE_APPROVED_ERROR,
  UPDATE_BUDGET_SUCCESS,
  UPDATE_BUDGET_ERROR,
  UPDATE_DELIVERABLE_IS_LIVE,
  LOAD_DISCUSSION_SUCCESS,
} from './constants';

const initialState = fromJS({
  discussionId: null,
  discussionType: null,
  name: null,
  organisations: null,
  loading: false,
  error: null,
  messages: [],
  documents: {},
  deliverables: {},
  currentBrief: null,
  currentContract: null,
  signedContract: null,
  docsStatus: {},
  deliverablesStatus: {},
  messagesLoading: false,
  trackedAssets: {},
  updatingDeliverableApprovalLoading: false,
  updatingDeliverableApprovalError: null,
});

function discussionsReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_DISCUSSION:
    return state
      .set('loading', true)
      .set('error', null);
  case LOAD_DISCUSSION_ERROR:
    return state
      .set('loading', false)
      .set('error', action.error);
  case LOAD_DISCUSSION_SUCCESS:
    return state
      .set('loading', false)
      .set('error', null);
  case LOAD_SENDBIRD_MESSAGES:
    return state
      .set('messages', action.messages.concat(state.get('messages')))
      .set('loading', false)
      .set('loadChannelError', false)
      .set('messagesLoading', false);
  case LOAD_MORE_MESSAGES:
    return state
      .set('messagesLoading', true);
  case UPDATE_MESSAGES:
    return state
      .set('messages', state.get('messages').concat(action.message));
  case UPDATE_DOCUMENTS:
    return state
      .set('documents', state.get('documents').set(action.documentData.get('id'), action.documentData));
  case REMOVE_DOCUMENT:
    return state
      .setIn(['documents', action.documentId, 'removed'], true)
      .setIn(['documents', action.documentId, 'filePath'], 'removed')
      .setIn(['documents', action.documentId, 'approved'], false);
  case UPDATE_DELIVERABLE_APPROVED:
    return state
      .set('updatingDeliverableApprovalError', null)
      .set('updatingDeliverableApprovalLoading', true);
  case UPDATE_DELIVERABLE_APPROVED_SUCCESS:
    return state
      .set('updatingDeliverableApprovalLoading', false);
  case UPDATE_DELIVERABLE_APPROVED_ERROR:
    return state
      .set('updatingDeliverableApprovalLoading', false)
      .set('updatingDeliverableApprovalError', action.error);
  case UPDATE_DELIVERABLES:
    return state
      .setIn(['deliverables', action.deliverableData.get('id')], action.deliverableData);
  case UPDATE_DELIVERABLE_IS_LIVE:
    return state
      .setIn(['deliverables', action.deliverableId, 'live'], action.live);
  case UPDATE_BUDGET_SUCCESS:
    return state
      .set('budget', action.budget).set('budgetStatus', action.status);
  case UPDATE_BUDGET_ERROR:
    return state
      .set('budgetError', action.error);
  case UPDATE_DELIVERABLE_DOCUMENT:
    return state
      .setIn(['deliverables', action.deliverableId, 'document'], action.documentData)
      .setIn(['deliverables', action.deliverableId, 'documents', action.documentData.get('version')], action.documentData)
      .setIn(['deliverables', action.deliverableId, 'mostRecentDocument'], action.documentData);
  case UPDATE_CURRENT_BRIEF:
    return state
      .set('currentBrief', action.currentBrief);
  case UPDATE_CURRENT_CONTRACT:
    return state
      .set('currentContract', action.currentContract);
  case UPDATE_SIGNED_CONTRACT:
    return state
      .set('signedContract', action.signedContract);
  case SET_DISCUSSION:
    return state
      .set('discussionId', action.discussionId)
      .set('name', action.name)
      .set('documents', action.documents)
      .set('organisations', action.organisations)
      .set('deliverables', action.deliverables)
      .set('currentBrief', action.currentBrief)
      .set('currentContract', action.currentContract)
      .set('signedContract', action.signedContract)
      .set('docsStatus', action.docsStatus)
      .set('deliverablesStatus', action.deliverablesStatus)
      .set('trackedAssets', action.trackedAssets)
      .set('budget', action.budget)
      .set('budgetStatus', action.budgetStatus)
      .set('organisations', action.organisations);
  case CLEAR_DISCUSSION:
    return initialState;
  case SET_DISCUSSION_TYPE:
    return state
      .set('discussionType', action.discussionType);
  case UPDATE_TRACKED_ASSETS:
    return state
      .setIn(['trackedAssets', action.trackedAsset.get('assetId')], action.trackedAsset);
  default:
    return state;
  }
}

export default discussionsReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/discussion/reducer.js
 **/